/**
 * Static master role → master permission mapping. Separate from the account `ROLE_PERMISSIONS`.
 */

import {
  ALL_MASTER_ACCOUNT_PERMISSIONS,
  MasterAccountPermission
} from './master-account-permission';
import { MasterAccountRole } from './master-account-role';

/** Each master role's permissions; a member's permissions are the union over their roles. */
export const MASTER_ACCOUNT_ROLE_PERMISSIONS: Record<
  MasterAccountRole,
  readonly MasterAccountPermission[]
> = {
  MASTER_ADMIN: ALL_MASTER_ACCOUNT_PERMISSIONS,
  MASTER_HEAD_ACCOUNTANT: [
    MasterAccountPermission.BOARD_READ,
    MasterAccountPermission.ASSIGNMENTS_MANAGE,
    MasterAccountPermission.DOCUMENTS_REASSIGN
  ],
  MASTER_ACCOUNTANT: [MasterAccountPermission.BOARD_READ]
};

/** All master permissions granted by a set of master roles (union, no duplicates). */
export function masterAccountPermissionsFor(
  roles: readonly MasterAccountRole[]
): readonly MasterAccountPermission[] {
  const granted = new Set<MasterAccountPermission>();
  for (const role of roles) {
    for (const permission of MASTER_ACCOUNT_ROLE_PERMISSIONS[role] ?? []) {
      granted.add(permission);
    }
  }
  return [...granted];
}
